export function formatPhoneNumber(value: string): string {
  if (!value) return "-";

  const cleanedValue = value.replace(/\D/g, "");

  if (cleanedValue.length !== 10) {
    return cleanedValue;
  }

  return `${cleanedValue.slice(0, 4)}-${cleanedValue.slice(4)}`;
}
